<template>
	<div class="collapse navbar-collapse w-auto h-auto h-100" id="sidenav-collapse-main">
		<ul class="navbar-nav">
			<li class="nav-item" v-for="(item, index) in menuItems" :key="index">
				<sidenav-item :url="item.url" :class="getRoute() === item.name ? 'active' : ''" :navText="item.title">
					<template v-slot:icon>
						<i class="ni text-primary text-sm opacity-10" :class="[item.icon, item.textColor]"></i>
					</template>
				</sidenav-item>
			</li>
		</ul>
	</div>
</template>
<script>
import SidenavItem from './SidenavItem.vue'
import { menu } from './menulist'

export default {
	name: 'SidenavList',
	props: {
		cardBg: String,
	},
	data() {
		return {
			title: 'Clube Gaspar',
			controls: 'dashboardsExamples',
			isActive: 'active',
			menuItems: [],
		}
	},
	components: {
		SidenavItem,
	},
	methods: {
		getRoute() {
			const routeArr = this.$route.path.split('/')
			return routeArr[1]
		},
	},
	created() {
		this.menuItems = menu
	},
}
</script>
